var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8288 1.08778C13.9381 1.19718 13.9995 1.34552 13.9995 1.5002C13.9995 1.65488 13.9381 1.80323 13.8288 1.91262L8.28708 7.45429C8.17769 7.56364 8.02935 7.62508 7.87467 7.62508C7.71999 7.62508 7.57164 7.56364 7.46225 7.45429L4.958 4.95003L0.995418 8.91262C0.8854 9.01888 0.738049 9.07767 0.5851 9.07635C0.432152 9.07502 0.285845 9.01367 0.17769 8.90551C0.0695356 8.79736 0.00818707 8.65105 0.00685799 8.4981C0.00552891 8.34515 0.0643256 8.1978 0.170585 8.08778L4.54558 3.71278C4.65498 3.60343 4.80332 3.54199 4.958 3.54199C5.11268 3.54199 5.26103 3.60343 5.37042 3.71278L7.87467 6.21703L13.0039 1.08778C13.1133 0.978426 13.2617 0.916992 13.4163 0.916992C13.571 0.916992 13.7194 0.978426 13.8288 1.08778Z",
    fill: "#27C453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33105 1.50033C9.33105 1.34562 9.39251 1.19724 9.50191 1.08785C9.6113 0.97845 9.75968 0.916992 9.91439 0.916992H13.4144C13.5691 0.916992 13.7175 0.97845 13.8269 1.08785C13.9363 1.19724 13.9977 1.34562 13.9977 1.50033V5.00033C13.9977 5.15504 13.9363 5.30341 13.8269 5.4128C13.7175 5.5222 13.5691 5.58366 13.4144 5.58366C13.2597 5.58366 13.1113 5.5222 13.0019 5.4128C12.8925 5.30341 12.8311 5.15504 12.8311 5.00033V2.08366H9.91439C9.75968 2.08366 9.6113 2.0222 9.50191 1.9128C9.39251 1.80341 9.33105 1.65504 9.33105 1.50033Z",
    fill: "#27C453"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/upIcon.b3495e989d8dcc5867d883419e2bfc25.svg";
export { ForwardRef as ReactComponent };